class CopyCodeButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          --copy-icon-color: var(--font-color);
          --copy-icon-hover-color: var(--active-font-color);
          --success-icon-color: #4caf50;
        }
        .copy-icon {
          width: 16px;
          height: 16px;
          fill: var(--copy-icon-color,red);
          transition: fill 0.2s ease;
        }
        .copy-icon:hover {
          fill: var(--copy-icon-hover-color);
        }
        .success-icon {
          width: 16px;
          height: 16px;
          fill: var(--success-icon-color);
          display: none;
        }

      </style>
      <svg class="copy-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path d="M668.437333 564.16V146.965333A104.32 104.32 0 0 0 564.138667 42.666667H146.986667C89.386667 42.666667 42.666667 89.365333 42.666667 146.986667v417.173333a104.32 104.32 0 0 0 104.32 104.298667h417.173333a104.32 104.32 0 0 0 104.277333-104.32z" fill=""></path>
          <path d="M877.013333 355.562667H746.666667V642.346667a104.32 104.32 0 0 1-104.32 104.32H355.562667v130.346666a104.32 104.32 0 0 0 104.32 104.32H877.013333a104.32 104.32 0 0 0 104.32-104.32V459.84a104.32 104.32 0 0 0-104.32-104.277333z" fill=""></path>
      </svg>
      <svg class="success-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path>
      </svg>
    `;

    this.copyIcon = this.shadowRoot.querySelector('.copy-icon');
    this.successIcon = this.shadowRoot.querySelector('.success-icon');

    this.copyIcon.addEventListener('click', this.copyCode.bind(this));

    this.resetIcon = this.resetIcon.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute('data-code') && this.parentElement) {
      const codeElement = this.parentElement.querySelector('code');
      if (codeElement) {
        this.setAttribute('data-code', codeElement.textContent);
      }
    }
  }

  resetIcon() {
    this.copyIcon.style.display = 'block';
    this.successIcon.style.display = 'none';
  }

  copyCode() {
    const code = this.getAttribute('data-code');
    if (!code) {
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          this.copyIcon.style.display = 'none';
          this.successIcon.style.display = 'block';
          setTimeout(() => {
            this.resetIcon();
          }, 1500);
        })
        .catch(() => {
          this.fallbackCopy(code);
        });
    } else {
      this.fallbackCopy(code);
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      const oldContentEditable = textArea.contentEditable;
      const oldReadOnly = textArea.readOnly;
      const oldSelectionStart = textArea.selectionStart;
      const oldSelectionEnd = textArea.selectionEnd;

      textArea.contentEditable = true;
      textArea.readOnly = false;

      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);

      textArea.contentEditable = oldContentEditable;
      textArea.readOnly = oldReadOnly;
      textArea.selectionStart = oldSelectionStart;
      textArea.selectionEnd = oldSelectionEnd;
    } else {
      textArea.select();
    }

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showSuccess();
      }
    } catch (err) {}

    document.body.removeChild(textArea);
  }
}

customElements.define('copy-code-button', CopyCodeButton);
